import TextField from "../../ui/TextField";
import Autocomplete from "../../ui/Autocomplete";
import { useEffect, useRef, useState, useCallback } from "react";
import { Box, Paper, Typography, Chip, CircularProgress, LinearProgress, Stack, Alert, Divider, Button, Backdrop } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import PsychologyIcon from "@mui/icons-material/Psychology";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { useRequest } from "../../../context/System/RequestContext";
import { useLayout } from "../../../context/System/LayoutContext";
import { useSesion } from "../../../context/System/SesionContext";
import { useIAEntrenamiento } from "../../../context/IA/IAEntrenamientoContext";
import ModalBuscarArticulosParaVenta from "../../herramientas/ModalBuscarArticulosParaVenta";
import SizeSoftXColectorCodigoBarras from "../../leyout/SizeSoftXColectorCodigoBarras.jsx";
import SizeSoftXLayoutForm from "../../leyout/SizeSoftXLayoutForm.jsx";
import MnuConteosInicializacionConFotoActions from "./MnuConteosInicializacionConFotoActions.jsx";
import FrmLoginValidate from "../../administracion/FrmLoginValidate.jsx";
import {
  apiBuscarArticulosInventario,
  apiBuscarArticuloPorCodigoBarras,
  apiIAInfoAprendizaje,
  apiIAEliminarEntrenamiento,
  apiListaAlmacenesExhibidores,
  apiTomaInventarioActivo,
  apiTomaInventarioAgregarArticulo,
  apiMedidasList,
  apiTomaInventarioSumarConteo1YFijar,
} from "../../../settings/ApiConfig";

const MUESTRAS_TOTAL = 10;
const IA_CONFIANZA_MINIMA = 0.9;
const IA_CONFIRMACIONES_REQUERIDAS = 2;
const IA_INTERVALO_BARRIDO_MS = 900;
const IA_TARGET_CROP_RATIO = 0.58;

const getMensajeResponse = (resp) => resp?.message || resp?.Message || "";
const getTieneError = (resp) => Boolean(resp?.hasError || resp?.HasError || resp?.haserror);
const textoNormalizado = (value) => String(value || "").trim().toUpperCase();
const limpiarZona = (value) => String(value || "")
  .split(".")
  .map((parte) => textoNormalizado(parte))
  .filter(Boolean)
  .join(".");
const construirZona = (almacen, folioInventario) => [
  textoNormalizado(almacen),
  textoNormalizado(folioInventario),
].filter(Boolean).join(".");

export default function ConteosInicializacionConFoto() {
  const { GetRequest, PostRequest, DeleteRequest } = useRequest();
  const { handleOpenAlert } = useLayout();
  const { usuario, parametrosCajaForm } = useSesion();
  const {
    handleSeleccionarArticulo,
    handleGuardarImagenArticulo,
    handleEnviarVectorEntrenamiento,
    handlePredecir,
    handleObtenerArticuloByClave,
    getArticuloImageDataUrl,
  } = useIAEntrenamiento();

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const fileInputRef = useRef(null);
  const mediaStreamRef = useRef(null);
  const articulosTemporalesRef = useRef([]);
  const barridoCandidatosRef = useRef({});
  const barridoTimerRef = useRef(null);
  const miniaturaFotoTimerRef = useRef(null);
  const dobleToqueFotoRef = useRef(0);
  const barridoAnalizandoRef = useRef(false);
  const barridoStorageCargadoRef = useRef(false);
  const barridoOmitirGuardadoRef = useRef(false);

  const [articuloCargado, setArticuloCargado] = useState(null);
  const [almacenExhibidor, setAlmacenExhibidor] = useState("");
  const [zona, setZona] = useState("");
  const [imagenCapturada, setImagenCapturada] = useState(null);
  const [miniaturaFoto, setMiniaturaFoto] = useState(null);
  const [loadingFoto, setLoadingFoto] = useState(false);
  const [agregando, setAgregando] = useState(false);
  const [openBuscarModal, setOpenBuscarModal] = useState(false);
  const [openLoginEliminarIA, setOpenLoginEliminarIA] = useState(false);
  const [listaAlmacenes, setListaAlmacenes] = useState([]);
  const [invActivo, setInvActivo] = useState(null);
  const [camaraIniciada, setCamaraIniciada] = useState(false);
  const [modoCamara, setModoCamara] = useState("environment");
  const [ultimoGuardado, setUltimoGuardado] = useState(null);
  const [fotoArticuloActual, setFotoArticuloActual] = useState(null);
  const [estadoInventarioArticulo, setEstadoInventarioArticulo] = useState("");
  const [identificandoIA, setIdentificandoIA] = useState(false);
  const [barridoActivo, setBarridoActivo] = useState(false);
  const [barridoMensaje, setBarridoMensaje] = useState("Listo para reconocer con el centro de la cémara.");
  const [ultimoBarrido, setUltimoBarrido] = useState(null);
  const [articulosTemporales, setArticulosTemporales] = useState([]);
  const [aplicandoTemporales, setAplicandoTemporales] = useState(false);
  const [aplicarBloqueado, setAplicarBloqueado] = useState(false);
  const [procesoAplicar, setProcesoAplicar] = useState("");
  const [medidasArticulo, setMedidasArticulo] = useState([]);
  const [medidaSeleccionada, setMedidaSeleccionada] = useState("");
  const [cantidadConteo1, setCantidadConteo1] = useState(1);

  const [infoAprendizaje, setInfoAprendizaje] = useState(null);
  const [sampleProgress, setSampleProgress] = useState({ active: false, current: 0, total: MUESTRAS_TOTAL });
  const [loadingAprendizaje, setLoadingAprendizaje] = useState(false);

  const barridoStorageKey = invActivo?.folioinventario
    ? [
      "sizesoftx_ia_barrido",
      invActivo.folioinventario,
      textoNormalizado(almacenExhibidor || invActivo.almacenexhibidor),
    ].join("_")
    : "";

  const iniciarCamara = useCallback(async (modoSolicitado = modoCamara) => {
    if (!navigator.mediaDevices?.getUserMedia) {
      handleOpenAlert("El navegador no permite acceso a cémara");
      return;
    }

    const detenerStreamActual = () => {
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach((track) => track.stop());
        mediaStreamRef.current = null;
      }
    };

    try {
      detenerStreamActual();
      if (videoRef.current) videoRef.current.srcObject = null;
      setCamaraIniciada(false);

      const videoBase = {
        width: { ideal: 1280 },
        height: { ideal: 720 },
      };
      const intentos = [
        { ...videoBase, facingMode: { exact: modoSolicitado } },
        { ...videoBase, facingMode: { ideal: modoSolicitado } },
        videoBase,
      ];

      let mediaStream = null;
      let ultimoError = null;
      for (const video of intentos) {
        try {
          mediaStream = await navigator.mediaDevices.getUserMedia({ video });
          break;
        } catch (error) {
          ultimoError = error;
        }
      }

      if (!mediaStream) throw ultimoError || new Error("No se pudo abrir la cémara");

      if (videoRef.current) videoRef.current.srcObject = mediaStream;
      mediaStreamRef.current = mediaStream;
      setModoCamara(modoSolicitado);
      setCamaraIniciada(true);
    } catch (err) {
      handleOpenAlert("Error al iniciar cémara: " + err.message);
    }
  }, [handleOpenAlert, modoCamara]);

  const detenerCamara = useCallback(() => {
    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((track) => track.stop());
      mediaStreamRef.current = null;
    }
    if (videoRef.current) videoRef.current.srcObject = null;
    setCamaraIniciada(false);
  }, []);

  const reactivarVideoCamara = useCallback(() => {
    const video = videoRef.current;
    const stream = mediaStreamRef.current;
    if (!video || !stream) return;

    if (video.srcObject !== stream) video.srcObject = stream;
    const playPromise = video.play?.();
    if (playPromise?.catch) playPromise.catch(() => {});
  }, []);

  const handleVolverCamara = useCallback(() => {
    setImagenCapturada(null);
    setTimeout(reactivarVideoCamara, 0);
  }, [reactivarVideoCamara]);

  const handleGirarCamara = useCallback(() => {
    setImagenCapturada(null);
    setBarridoActivo(false);
    const siguienteModo = modoCamara === "environment" ? "user" : "environment";
    iniciarCamara(siguienteModo);
  }, [iniciarCamara, modoCamara]);

  const mostrarMiniaturaFoto = useCallback((imagenBase64) => {
    if (miniaturaFotoTimerRef.current) clearTimeout(miniaturaFotoTimerRef.current);
    setMiniaturaFoto(imagenBase64);
    miniaturaFotoTimerRef.current = setTimeout(() => {
      setMiniaturaFoto(null);
      miniaturaFotoTimerRef.current = null;
    }, 3500);
  }, []);

  useEffect(() => {
    const inicializar = async () => {
      const inventario = await GetRequest({
        url: apiTomaInventarioActivo,
        loader: false,
      });
      if (!getTieneError(inventario) && inventario?.result?.folioinventario > 0) {
        setInvActivo(inventario.result);
        setAlmacenExhibidor(inventario.result.almacenexhibidor || "");
      } else {
        handleOpenAlert("No hay un inventario activo");
      }

      const almacenesRes = await GetRequest({
        url: apiListaAlmacenesExhibidores,
        loader: false,
      });
      if (!getTieneError(almacenesRes) && Array.isArray(almacenesRes?.result)) {
        setListaAlmacenes(almacenesRes.result);
      }
    };

    inicializar();
    iniciarCamara();
    return () => detenerCamara();
  }, []);

  useEffect(() => {
    if (!imagenCapturada) reactivarVideoCamara();
  }, [imagenCapturada, reactivarVideoCamara]);

  useEffect(() => () => {
    if (barridoTimerRef.current) clearTimeout(barridoTimerRef.current);
    if (miniaturaFotoTimerRef.current) clearTimeout(miniaturaFotoTimerRef.current);
  }, []);

  useEffect(() => {
    articulosTemporalesRef.current = articulosTemporales;
  }, [articulosTemporales]);

  useEffect(() => {
    setAplicarBloqueado(false);
  }, [medidaSeleccionada, articuloCargado?.clavearticulo]);

  useEffect(() => {
    barridoStorageCargadoRef.current = false;
    barridoOmitirGuardadoRef.current = true;

    if (!barridoStorageKey) {
      setArticulosTemporales([]);
      barridoStorageCargadoRef.current = true;
      return;
    }

    try {
      const raw = localStorage.getItem(barridoStorageKey);
      const guardados = raw ? JSON.parse(raw) : [];
      setArticulosTemporales(Array.isArray(guardados) ? guardados : []);
    } catch {
      setArticulosTemporales([]);
    } finally {
      barridoStorageCargadoRef.current = true;
    }
  }, [barridoStorageKey]);

  useEffect(() => {
    if (!barridoStorageKey || !barridoStorageCargadoRef.current) return;
    if (barridoOmitirGuardadoRef.current) {
      barridoOmitirGuardadoRef.current = false;
      return;
    }

    if (articulosTemporales.length === 0) {
      localStorage.removeItem(barridoStorageKey);
      return;
    }

    localStorage.setItem(barridoStorageKey, JSON.stringify(articulosTemporales));
  }, [articulosTemporales, barridoStorageKey]);

  useEffect(() => {
    setZona(construirZona(almacenExhibidor, invActivo?.folioinventario));
  }, [almacenExhibidor, invActivo?.folioinventario]);

  const capturarImagen = useCallback((quality = 0.82) => {
    if (!videoRef.current || !canvasRef.current) return null;

    const videoElement = videoRef.current;
    const canvasElement = canvasRef.current;
    const vw = videoElement.videoWidth || 640;
    const vh = videoElement.videoHeight || 480;
    const baseSize = Math.min(vw, vh);
    const size = Math.max(80, baseSize * IA_TARGET_CROP_RATIO);
    const sx = (vw - size) / 2;
    const sy = (vh - size) / 2;

    canvasElement.width = 320;
    canvasElement.height = 320;
    const ctx = canvasElement.getContext("2d");
    if (!ctx) return null;

    ctx.drawImage(videoElement, sx, sy, size, size, 0, 0, 320, 320);
    return canvasElement.toDataURL("image/jpeg", quality);
  }, []);

  const recortarImagenCentro = useCallback((dataUrl, quality = 0.82) => new Promise((resolve) => {
    if (!dataUrl || !canvasRef.current) {
      resolve(dataUrl);
      return;
    }

    const image = new Image();
    image.onload = () => {
      const canvasElement = canvasRef.current;
      const iw = image.naturalWidth || image.width;
      const ih = image.naturalHeight || image.height;
      const baseSize = Math.min(iw, ih);
      const size = Math.max(80, baseSize * IA_TARGET_CROP_RATIO);
      const sx = (iw - size) / 2;
      const sy = (ih - size) / 2;
      canvasElement.width = 320;
      canvasElement.height = 320;
      const ctx = canvasElement.getContext("2d");
      if (!ctx) {
        resolve(dataUrl);
        return;
      }
      ctx.drawImage(image, sx, sy, size, size, 0, 0, 320, 320);
      resolve(canvasElement.toDataURL("image/jpeg", quality));
    };
    image.onerror = () => resolve(dataUrl);
    image.src = dataUrl;
  }), []);

  const getConfianzaPrediccion = (prediccion) => {
    const raw = prediccion?.confianza ?? prediccion?.confidence ?? prediccion?.porcentaje ?? 0;
    const valor = Number(raw || 0);
    return valor > 1 ? valor / 100 : valor;
  };

  const handleSubirFoto = (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) setImagenCapturada(reader.result);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };

  const focusLector = () => {
    setTimeout(() => {
      document.getElementById("txtCodigoBarras")?.focus();
      document.getElementById("txtCodigoBarras")?.select();
    }, 120);
  };

  const normalizarArticulo = (dataArticulo = {}) => ({
    clavearticulo: textoNormalizado(dataArticulo.clavearticulo || dataArticulo.claveArticulo || dataArticulo.sClaveArticulo),
    descripcion: dataArticulo.descripcion || dataArticulo.descripcionArticulo || dataArticulo.sDescripcion || "",
    codigobarras: dataArticulo.codigobarras || dataArticulo.codigoBarras || dataArticulo.sCodigoBarras || "",
    factor: Number(dataArticulo.factor || dataArticulo.dFactor || dataArticulo.fFactor || 1),
    listamedidas: dataArticulo.listamedidas || dataArticulo.lMedidas || dataArticulo.medidas || [],
  });

  const normalizarMedidasArticulo = (items = []) => (Array.isArray(items) ? items : [])
    .map((item) => ({
      medida: Number(item.medida ?? item.dMedida ?? item.fMedida ?? item.Medida ?? 0),
      codigobarras: item.codigobarras || item.codigoBarras || item.sCodigoBarras || "",
      existencia: Number(item.existencia ?? item.dExistencia ?? item.Existencia ?? 0),
      conteo1: Number(item.conteo1 ?? item.dConteo1 ?? item.Conteo1 ?? 0),
    }))
    .filter((item) => Number.isFinite(item.medida))
    .sort((a, b) => a.medida - b.medida);

  const cargarMedidasArticulo = useCallback(async (articulo) => {
    const medidasLocales = normalizarMedidasArticulo(articulo?.listamedidas || articulo?.lMedidas || articulo?.medidas || []);
    if (medidasLocales.length) {
      setMedidasArticulo(medidasLocales);
      setMedidaSeleccionada((actual) => medidasLocales.some((item) => Number(item.medida) === Number(actual)) ? actual : medidasLocales[0].medida);
      return medidasLocales;
    }

    const clave = textoNormalizado(articulo?.clavearticulo);
    if (!clave) {
      setMedidasArticulo([]);
      setMedidaSeleccionada("");
      return [];
    }

    const resp = await GetRequest({
      url: apiMedidasList.replace("{clavearticulo}", clave),
      loader: false,
    });

    if (getTieneError(resp)) {
      setMedidasArticulo([]);
      setMedidaSeleccionada("");
      return [];
    }

    const result = resp?.result;
    const origen = Array.isArray(result)
      ? result
      : Array.isArray(result?.listamedidas)
        ? result.listamedidas
        : Array.isArray(result?.lMedidas)
          ? result.lMedidas
          : [];
    const medidas = normalizarMedidasArticulo(origen);
    setMedidasArticulo(medidas);
    setMedidaSeleccionada((actual) => medidas.some((item) => Number(item.medida) === Number(actual)) ? actual : (medidas[0]?.medida ?? ""));
    return medidas;
  }, [GetRequest]);


  const agregarArticuloAlInventario = async (clave) => {
    if (!invActivo?.folioinventario) {
      handleOpenAlert("No hay inventario activo");
      return null;
    }

    const body = {
      folioinventario: invActivo.folioinventario,
      almacenexhibidor: textoNormalizado(invActivo.almacenexhibidor || almacenExhibidor),
      clavearticulo: textoNormalizado(clave),
      usuarioresponsable: usuario?.usuario || "ADMIN",
      pc: textoNormalizado(parametrosCajaForm?.caja),
    };

    const resp = await PostRequest({
      url: apiTomaInventarioAgregarArticulo,
      body,
      loader: "Validando artículo en inventario...",
    });

    if (getTieneError(resp)) {
      const mensaje = getMensajeResponse(resp);
      const mensajeNormalizado = textoNormalizado(mensaje);
      const yaRegistrado = mensajeNormalizado.includes("YA EST") && mensajeNormalizado.includes("REGISTRADO");
      if (!yaRegistrado) {
        handleOpenAlert("Error al agregar artículo: " + mensaje);
        return null;
      }
    }

    return resp;
  };

  const registrarArticuloTemporalIA = useCallback(async (prediccion, imagenBase64, origen = "IA") => {
    const confianza = getConfianzaPrediccion(prediccion);
    const clavePredicha = textoNormalizado(prediccion?.clavearticulo || prediccion?.sClaveArticulo || prediccion?.claveArticulo);
    if (!clavePredicha || confianza < IA_CONFIANZA_MINIMA) return false;

    const articuloIA = await handleObtenerArticuloByClave(clavePredicha);
    const articulo = normalizarArticulo(articuloIA || { clavearticulo: clavePredicha });
    if (!articulo.clavearticulo) return false;

    const ahora = new Date().toISOString();
    const itemTemporal = {
      ...articulo,
      confianza: Number((confianza * 100).toFixed(2)),
      ultimaDeteccion: ahora,
      origen,
      imagenBase64,
    };

    setArticulosTemporales((prev) => {
      const existe = prev.find((item) => item.clavearticulo === itemTemporal.clavearticulo);
      if (!existe) return [{ ...itemTemporal, veces: 1 }, ...prev];

      return prev.map((item) => item.clavearticulo === itemTemporal.clavearticulo
        ? {
          ...item,
          ...itemTemporal,
          confianza: Math.max(Number(item.confianza || 0), itemTemporal.confianza),
          veces: Number(item.veces || 1) + 1,
        }
        : item);
    });

    const fotoActual = getArticuloImageDataUrl?.(articuloIA) || getArticuloImageDataUrl?.(articulo) || null;
    setFotoArticuloActual(fotoActual);
    setArticuloCargado(articulo);
    handleSeleccionarArticulo(articulo);
    await cargarMedidasArticulo(articulo);
    setUltimoGuardado(null);
    setEstadoInventarioArticulo(`Detectado por ${origen}. Aplique la lista temporal para integrarlo al inventario activo con sus medidas.`);
    await handleObtenerInfoAprendizaje(articulo.clavearticulo);
    setUltimoBarrido({ clave: articulo.clavearticulo, confianza: itemTemporal.confianza, hora: new Date().toLocaleTimeString() });
    setBarridoMensaje(`Detectado ${articulo.clavearticulo} con ${itemTemporal.confianza}% de confianza.`);
    return true;
  }, [cargarMedidasArticulo, handleObtenerArticuloByClave, handleSeleccionarArticulo]);

  const handleIdentificarConIA = async () => {
    if (identificandoIA || sampleProgress.active) return;

    const usandoFotoFija = Boolean(imagenCapturada);
    const imagenBase64 = usandoFotoFija ? await recortarImagenCentro(imagenCapturada) : capturarImagen();
    if (!imagenBase64) {
      handleOpenAlert("Capture o cargue una foto primero");
      return;
    }

    setIdentificandoIA(true);
    try {
      const prediccion = await handlePredecir(imagenBase64, { minConfidence: IA_CONFIANZA_MINIMA });
      const registrado = await registrarArticuloTemporalIA(prediccion, imagenBase64, "Foto IA");
      if (!registrado) {
        handleOpenAlert("IA no encontró coincidencia confiable para la foto");
        return;
      }

      if (usandoFotoFija) setImagenCapturada(imagenBase64);
      handleOpenAlert("Artículo enviado a la lista temporal", "ok");
    } finally {
      setIdentificandoIA(false);
    }
  };

  const capturarArticuloPorCodigo = async (codigobarras) => {
    const codigo = codigobarras.trim();
    if (!codigo || !invActivo?.folioinventario) return null;

    const responseInventario = await GetRequest({
      url: apiBuscarArticulosInventario
        .replace("{folioinventario}", invActivo.folioinventario)
        .replace("{codigobarras}", codigo),
      loader: false,
    });

    if (!getTieneError(responseInventario)) {
      const articuloInventario = normalizarArticulo(responseInventario?.result);
      if (articuloInventario.clavearticulo) return articuloInventario;
    }

    const responseCatalogo = await GetRequest({
      url: apiBuscarArticuloPorCodigoBarras.replace("{codigobarras}", codigo),
      alert: "Buscando artículo en catélogo",
    });

    if (getTieneError(responseCatalogo)) {
      handleOpenAlert("Artículo no encontrado en inventario activo ni en catélogo");
      return null;
    }

    const articuloCatalogo = normalizarArticulo(responseCatalogo?.result);
    if (!articuloCatalogo.clavearticulo) {
      handleOpenAlert("El código existe, pero no tiene clave de artículo vélida");
      return null;
    }

    return articuloCatalogo;
  };
  const handleObtenerInfoAprendizaje = async (claveArticulo) => {
    const clave = textoNormalizado(claveArticulo);
    if (!clave) return;

    setLoadingAprendizaje(true);
    const resp = await GetRequest({
      url: apiIAInfoAprendizaje.replace("{claveArticulo?}", clave),
      loader: false,
    });
    setLoadingAprendizaje(false);

    if (!getTieneError(resp)) {
      const arr = Array.isArray(resp.result) ? resp.result : [];
      const found = arr.find((i) => textoNormalizado(i.clavearticulo || i.sClaveArticulo) === clave);
      setInfoAprendizaje(found || null);
    }
  };

  const ejecutarEliminarEntrenamiento = async () => {
    if (!articuloCargado?.clavearticulo) return;

    const clave = textoNormalizado(articuloCargado.clavearticulo);
    const resp = await DeleteRequest({
      url: apiIAEliminarEntrenamiento.replace("{claveArticulo}", clave),
      loader: "Eliminando entrenamiento...",
    });

    if (!getTieneError(resp)) {
      setInfoAprendizaje(null);
      handleOpenAlert("Entrenamiento eliminado correctamente", "ok");
    } else {
      handleOpenAlert("Error al eliminar entrenamiento: " + getMensajeResponse(resp));
    }
  };

  const solicitarEliminarEntrenamiento = () => {
    if (!articuloCargado?.clavearticulo) return;
    setOpenLoginEliminarIA(true);
  };

  const cargarArticuloEnPanel = async (articulo, respInventario) => {
    const mensaje = getMensajeResponse(respInventario).toLowerCase();
    const yaRegistrado = mensaje.includes("ya est") || mensaje.includes("registrado");
    const estado = yaRegistrado
      ? "Artículo ya estaba en la toma. Puede actualizar foto y entrenamiento sin duplicar registro."
      : "Artículo agregado al selectivo con sus medidas activas.";

    const articuloIA = await handleObtenerArticuloByClave(articulo.clavearticulo);
    const articuloPanel = normalizarArticulo({ ...articulo, ...(articuloIA || {}) });
    const fotoActual = getArticuloImageDataUrl?.(articuloIA) || getArticuloImageDataUrl?.(articulo) || null;
    setFotoArticuloActual(fotoActual);
    setArticuloCargado(articuloPanel);
    handleSeleccionarArticulo(articuloPanel);
    await cargarMedidasArticulo(articuloPanel);
    setImagenCapturada(null);
    setUltimoGuardado(null);
    setEstadoInventarioArticulo(estado);
    await handleObtenerInfoAprendizaje(articuloPanel.clavearticulo);
  };

  const registrarArticuloEnInventario = async (dataArticulo) => {
    const articulo = normalizarArticulo(dataArticulo);
    if (!articulo.clavearticulo) return false;

    setAgregando(true);
    try {
      const resp = await agregarArticuloAlInventario(articulo.clavearticulo);
      if (!resp) return false;
      await cargarArticuloEnPanel(articulo, resp);
      return true;
    } finally {
      setAgregando(false);
      focusLector();
    }
  };

  const handleArticuloSeleccionado = async (data, almacen) => {
    if (!data?.clavearticulo && !data?.codigobarras && !data?.sClaveArticulo) return;
    if (almacen) setAlmacenExhibidor(textoNormalizado(almacen));
    await registrarArticuloEnInventario(data);
    setOpenBuscarModal(false);
  };


  const aplicarConteo1Articulo = async () => {
    if (!articuloCargado?.clavearticulo || medidaSeleccionada === "" || medidaSeleccionada === null) return false;

    const cantidad = Number(cantidadConteo1);
    if (!Number.isFinite(cantidad) || cantidad <= 0) {
      handleOpenAlert("Capture una cantidad mayor a cero para Conteo 1");
      return false;
    }

    const clave = textoNormalizado(articuloCargado.clavearticulo);
    const medida = Number(medidaSeleccionada);
    const zonaConteo = limpiarZona(zona) || construirZona(almacenExhibidor || invActivo?.almacenexhibidor, invActivo?.folioinventario);
    const resp = await PostRequest({
      url: apiTomaInventarioSumarConteo1YFijar.replace("{folioinventario}", invActivo.folioinventario),
      body: { claveArticulo: clave, medida, cantidad, zona: zonaConteo, Zona: zonaConteo, sZona: zonaConteo },
      loader: "Actualizando Conteo 1...",
    });

    if (getTieneError(resp)) {
      handleOpenAlert("Error al actualizar Conteo 1: " + getMensajeResponse(resp));
      return false;
    }

    const conteoNuevo = Number(resp?.result ?? resp?.Result ?? 0);

    setMedidasArticulo((prev) => prev.map((item) => Number(item.medida) === medida ? { ...item, conteo1: conteoNuevo } : item));
    setEstadoInventarioArticulo(`Conteo 1 fijado en talla ${medida}. Cantidad acumulada: ${conteoNuevo}. Zona: ${zonaConteo}.`);
    return true;
  };

  const handleAplicarArticulosTemporales = async () => {
    if (aplicarBloqueado) return;

    const tieneArticuloParaConteo = Boolean(articuloCargado?.clavearticulo && medidaSeleccionada !== "" && medidaSeleccionada !== null);
    if (!articulosTemporalesRef.current.length && !tieneArticuloParaConteo) return;
    if (!invActivo?.folioinventario) {
      handleOpenAlert("No hay inventario activo");
      return;
    }

    setAplicandoTemporales(true);
    setProcesoAplicar("Tomando foto y aplicando lista temporal...");
    setBarridoActivo(false);
    let aplicados = 0;
    let conteoAplicado = false;
    let fotoGuardada = false;

    try {
      if (tieneArticuloParaConteo) {
        fotoGuardada = await guardarFotoArticuloActual();
      }

      setProcesoAplicar("Validando artículos en inventario...");
      const mapaArticulos = new Map(
        articulosTemporalesRef.current.map((articulo) => [textoNormalizado(articulo.clavearticulo), articulo])
      );
      if (articuloCargado?.clavearticulo) {
        mapaArticulos.set(textoNormalizado(articuloCargado.clavearticulo), articuloCargado);
      }
      const articulosUnicos = Array.from(mapaArticulos.values());

      for (const articulo of articulosUnicos) {
        const claveTemporal = textoNormalizado(articulo.clavearticulo);
        const resp = await agregarArticuloAlInventario(claveTemporal);
        if (resp) aplicados += 1;
      }

      if (tieneArticuloParaConteo) {
        setProcesoAplicar("Actualizando Conteo 1...");
        conteoAplicado = await aplicarConteo1Articulo();
      }

      setArticulosTemporales([]);
      if (barridoStorageKey) localStorage.removeItem(barridoStorageKey);
      handleOpenAlert(`${aplicados} artículo(s) validado(s) en selectivo${conteoAplicado ? " y Conteo 1 actualizado" : ""}${fotoGuardada ? " y foto guardada" : ""}`, "ok");
      setAplicarBloqueado(true);
    } finally {
      setAplicandoTemporales(false);
      setProcesoAplicar("");
      focusLector();
    }
  };

  const handleLimpiarArticulosTemporales = () => {
    const hayDatosTemporales = articulosTemporalesRef.current.length || articuloCargado || imagenCapturada || ultimoBarrido;
    if (!hayDatosTemporales) return;
    if (!window.confirm("¿Limpiar la lista temporal y el artículo cargado?")) return;

    setBarridoActivo(false);
    setArticulosTemporales([]);
    barridoCandidatosRef.current = {};
    if (barridoStorageKey) localStorage.removeItem(barridoStorageKey);
    setArticuloCargado(null);
    setMedidasArticulo([]);
    setMedidaSeleccionada("");
    setCantidadConteo1(1);
    handleSeleccionarArticulo(null);
    setEstadoInventarioArticulo("");
    setUltimoGuardado(null);
    setInfoAprendizaje(null);
    setUltimoBarrido(null);
    handleVolverCamara();
    setBarridoMensaje("Lista temporal limpia. Puede iniciar otro barrido.");
  };

  const guardarFotoArticuloActual = async () => {
    if (!articuloCargado?.clavearticulo) return false;

    const imagenBase64 = imagenCapturada || (camaraIniciada ? capturarImagen() : null);
    if (!imagenBase64) return false;

    const guardado = await handleGuardarImagenArticulo(imagenBase64, articuloCargado);
    if (!guardado) return false;

    mostrarMiniaturaFoto(imagenBase64);
    setFotoArticuloActual(imagenBase64);
    setUltimoGuardado({ clave: articuloCargado.clavearticulo, hora: new Date().toLocaleTimeString() });
    setArticuloCargado((prev) => prev ? {
      ...prev,
      imagenbase64: imagenBase64,
      imagen: imagenBase64,
    } : prev);
    if (!imagenCapturada) reactivarVideoCamara();
    return true;
  };

  const handleTomarFoto = async () => {
    if (!articuloCargado) {
      handleOpenAlert("Cargue un artículo primero");
      return;
    }

    const imagenBase64 = imagenCapturada || (camaraIniciada ? capturarImagen() : null);
    if (!imagenBase64) {
      handleOpenAlert("Capture o cargue una imagen primero");
      return;
    }

    setLoadingFoto(true);
    try {
      const guardado = await guardarFotoArticuloActual();
      if (guardado) {
        handleOpenAlert("Foto guardada correctamente", "ok");
      }
    } catch (err) {
      handleOpenAlert("Error al guardar foto: " + err.message);
    } finally {
      setLoadingFoto(false);
    }
  };


  const handleDobleClickCamaraFoto = (event) => {
    event?.preventDefault?.();
    if (loadingFoto || loadingAprendizaje || sampleProgress.active || identificandoIA || aplicandoTemporales || agregando) return;
    handleTomarFoto();
  };

  const handleDobleToqueCamaraFoto = (event) => {
    const ahora = Date.now();
    if (ahora - dobleToqueFotoRef.current <= 360) {
      dobleToqueFotoRef.current = 0;
      handleDobleClickCamaraFoto(event);
      return;
    }
    dobleToqueFotoRef.current = ahora;
  };
  const handleEntrenarMuestras = async () => {
    if (!articuloCargado || sampleProgress.active) return;

    setLoadingAprendizaje(true);
    setSampleProgress({ active: true, current: 0, total: MUESTRAS_TOTAL });

    for (let i = 0; i < MUESTRAS_TOTAL; i++) {
      setSampleProgress({ active: true, current: i + 1, total: MUESTRAS_TOTAL });
      const imagenBase64 = capturarImagen();
      if (imagenBase64) {
        await handleEnviarVectorEntrenamiento(imagenBase64, articuloCargado, { silent: true });
      }
      await new Promise((resolve) => setTimeout(resolve, i < 4 ? 1000 : 200));
    }

    await handleObtenerInfoAprendizaje(articuloCargado.clavearticulo);
    setSampleProgress({ active: false, current: 0, total: MUESTRAS_TOTAL });
    setLoadingAprendizaje(false);
    handleOpenAlert("Entrenamiento enviado correctamente", "ok");
  };

  useEffect(() => {
    if (!barridoActivo) {
      if (barridoTimerRef.current) clearTimeout(barridoTimerRef.current);
      barridoAnalizandoRef.current = false;
      return;
    }

    if (!camaraIniciada || imagenCapturada || sampleProgress.active) {
      setBarridoMensaje("Active la cémara sin foto fija para iniciar el barrido visual.");
      setBarridoActivo(false);
      return;
    }

    const analizarFrame = async () => {
      if (barridoAnalizandoRef.current) return;

      const imagenBase64 = capturarImagen(0.72);
      if (!imagenBase64) return;

      barridoAnalizandoRef.current = true;
      try {
        const prediccion = await handlePredecir(imagenBase64, { minConfidence: IA_CONFIANZA_MINIMA, silent: true });
        const clavePredicha = textoNormalizado(prediccion?.clavearticulo || prediccion?.sClaveArticulo || prediccion?.claveArticulo);
        const confianza = getConfianzaPrediccion(prediccion);

        if (!clavePredicha || confianza < IA_CONFIANZA_MINIMA) {
          setBarridoMensaje("Buscando coincidencia confiable en el centro de la cémara...");
          barridoCandidatosRef.current = {};
          return;
        }

        const candidato = barridoCandidatosRef.current[clavePredicha] || { veces: 0 };
        const veces = candidato.veces + 1;
        barridoCandidatosRef.current = { [clavePredicha]: { veces, confianza } };
        setBarridoMensaje(`Posible ${clavePredicha}: ${Math.round(confianza * 100)}% (${veces}/${IA_CONFIRMACIONES_REQUERIDAS}).`);

        if (veces >= IA_CONFIRMACIONES_REQUERIDAS) {
          barridoCandidatosRef.current = {};
          await registrarArticuloTemporalIA(prediccion, imagenBase64, "Barrido IA");
        }
      } finally {
        barridoAnalizandoRef.current = false;
      }
    };

    const programarBarrido = async () => {
      await analizarFrame();
      barridoTimerRef.current = setTimeout(programarBarrido, IA_INTERVALO_BARRIDO_MS);
    };

    barridoTimerRef.current = setTimeout(programarBarrido, 250);
    return () => {
      if (barridoTimerRef.current) clearTimeout(barridoTimerRef.current);
    };
  }, [barridoActivo, camaraIniciada, imagenCapturada, sampleProgress.active, capturarImagen, handlePredecir, registrarArticuloTemporalIA]);

  const getStatusColor = (p) => {
    if (p >= 100) return "success";
    if (p >= 50) return "info";
    if (p > 0) return "warning";
    return "primary";
  };

  const porcentaje = Number(infoAprendizaje?.porcentaje ?? infoAprendizaje?.dPorcentaje ?? 0);
  const vectores = Number(infoAprendizaje?.totalvectores ?? infoAprendizaje?.totalVectores ?? infoAprendizaje?.iTotalVectores ?? 0);
  const accionesBloqueadas = loadingFoto || loadingAprendizaje || sampleProgress.active || identificandoIA || aplicandoTemporales || agregando;
  const puedeAplicarConteo = Boolean(articuloCargado?.clavearticulo && medidaSeleccionada !== "" && medidaSeleccionada !== null);
  const aplicarDeshabilitado = accionesBloqueadas || aplicarBloqueado;
  const barridoColor = barridoActivo ? "success.main" : ultimoBarrido ? "warning.main" : "primary.main";
  const actionsMenu = (
    <MnuConteosInicializacionConFotoActions
      onBuscarArticulo={() => setOpenBuscarModal(true)}
      onIdentificarIA={handleIdentificarConIA}
      onToggleBarrido={() => setBarridoActivo((prev) => !prev)}
      onGuardarFoto={handleTomarFoto}
      onCargarFoto={() => fileInputRef.current?.click()}
      onVolverCamara={handleVolverCamara}
      onGirarCamara={handleGirarCamara}
      onAplicarTemporal={handleAplicarArticulosTemporales}
      onLimpiarTemporal={handleLimpiarArticulosTemporales}
      onEntrenarMuestras={handleEntrenarMuestras}
      onEliminarEntrenamiento={solicitarEliminarEntrenamiento}
      barridoActivo={barridoActivo}
      hayCamara={camaraIniciada}
      hayImagen={Boolean(imagenCapturada)}
      hayArticulo={Boolean(articuloCargado)}
      hayTemporales={Boolean(articulosTemporales.length)}
      puedeAplicarConteo={puedeAplicarConteo}
      aplicarBloqueado={aplicarDeshabilitado}
      hayInventarioActivo={Boolean(invActivo?.folioinventario)}
      hayEntrenamiento={vectores > 0}
      bloqueado={accionesBloqueadas}
    />
  );

  return (
    <SizeSoftXLayoutForm titlePage="Conteos - Inicialización con Foto" buttonActions={actionsMenu}>
      <Box sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "clamp(410px, 24vw, 460px) minmax(0, 1fr)" },
          gap: 2,
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          pr: { xs: 0, md: 0.5 },
          pb: 8,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, minWidth: 0 }}>
          <Paper sx={{ p: 2, borderRadius: 2, overflow: "hidden" }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
              Buscar artículo
            </Typography>
            <SizeSoftXColectorCodigoBarras
              TipoVentana="CONTEOS_INICIALIZACION"
              onRegistrarArticulo={registrarArticuloEnInventario}
              onCompletado={focusLector}
              customArticleLookup={capturarArticuloPorCodigo}
              disabled={!invActivo?.folioinventario || agregando}
              limpiarColaAlFallar={false}
            />
          </Paper>

          <Paper sx={{ p: 2, borderRadius: 2, overflow: "hidden" }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
              <Inventory2Icon fontSize="small" /> Artículo en toma {agregando && <CircularProgress size={14} />}
            </Typography>

            {articuloCargado ? (
              <Stack spacing={1.2}>
                <Box sx={{ display: "grid", gridTemplateColumns: fotoArticuloActual ? "72px minmax(0, 1fr)" : "1fr", gap: 1.2, alignItems: "center" }}>
                  {fotoArticuloActual && (
                    <Box component="img" src={fotoArticuloActual} alt="Foto actual del artículo" sx={{ width: 72, height: 72, borderRadius: 1.5, objectFit: "cover", border: "1px solid #d0d7de", bgcolor: "grey.100" }} />
                  )}
                  <Box>
                    <Typography variant="caption" color="text.secondary">Clave</Typography>
                    <Box><Chip label={articuloCargado.clavearticulo} color="primary" size="small" /></Box>
                    {fotoArticuloActual && <Typography variant="caption" color="text.secondary">Foto actual</Typography>}
                  </Box>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">Descripción</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{articuloCargado.descripcion}</Typography>
                </Box>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems="stretch">
                  <Autocomplete
                    options={medidasArticulo}
                    value={medidasArticulo.find((item) => Number(item.medida) === Number(medidaSeleccionada)) || null}
                    onChange={(_, item) => setMedidaSeleccionada(item?.medida ?? "")}
                    getOptionLabel={(item) => item ? `${item.medida}${Number(item.conteo1 || 0) ? ` | C1: ${item.conteo1}` : ""}` : ""}
                    isOptionEqualToValue={(option, value) => Number(option.medida) === Number(value.medida)}
                    disabled={!medidasArticulo.length || aplicandoTemporales}
                    sx={{ flex: 1, minWidth: 0 }}
                    renderInput={(params) => <TextField {...params} label="Talla para Conteo 1" size="small" />}
                  />
                  <TextField autoComplete="off"
                    label="Cantidad"
                    type="text"
                    inputMode="numeric"
                    enterKeyHint="enter"
                    size="small"
                    value={cantidadConteo1}
                    onChange={(e) => setCantidadConteo1(e.target.value)}
                    disabled={aplicandoTemporales}
                    slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
                    sx={{ width: { xs: "100%", sm: 130 } }}
                  />
                </Stack>
                {estadoInventarioArticulo && <Alert severity="info">{estadoInventarioArticulo}</Alert>}

                {ultimoGuardado && ultimoGuardado.clave === articuloCargado.clavearticulo && (
                  <Chip icon={<CheckCircleIcon />} label={`Foto OK ${ultimoGuardado.hora}`} color="success" size="small" />
                )}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">Ningún artículo cargado</Typography>
            )}
          </Paper>

          <Paper sx={{ p: 2, borderRadius: 2, overflow: "hidden" }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
              <PlaylistAddCheckIcon fontSize="small" color="primary" /> Lista temporal IA
            </Typography>
            <Alert severity={barridoActivo ? "success" : ultimoBarrido ? "warning" : "info"} sx={{ mb: 1.5 }}>
              {barridoMensaje}
            </Alert>
            {articulosTemporales.length ? (
              <Stack spacing={1} divider={<Divider flexItem />} sx={{ maxHeight: { xs: 240, lg: 300 }, overflowY: "auto", pr: 0.5 }}>
                {articulosTemporales.map((item) => (
                  <Box key={item.clavearticulo} sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "92px minmax(0, 1fr) auto" }, gap: 1, alignItems: "center" }}>
                    <Chip label={`${item.confianza || 0}%`} color={Number(item.confianza || 0) >= 90 ? "success" : "warning"} size="small" />
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="body2" sx={{ fontWeight: 800 }}>{item.clavearticulo}</Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {item.descripcion || "Sin descripción"}
                      </Typography>
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      {item.origen || "IA"}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Apunte el centro de la cémara al artículo; con 90% o més de confianza se guardaré aquí hasta aplicar.
              </Typography>
            )}
          </Paper>
          <Paper sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>Configuración de toma</Typography>
            <Autocomplete
              freeSolo
              options={listaAlmacenes.map((a) => a.nombre || a.almacenexhibidor || a)}
              value={almacenExhibidor}
              onInputChange={(_, val) => setAlmacenExhibidor(val || "")}
              renderInput={(params) => <TextField {...params} label="Almacén / Exhibidor" variant="outlined" size="small" fullWidth />}
            />
            <TextField autoComplete="off"
              label="Zona"
              variant="outlined"
              size="small"
              fullWidth
              value={zona}
              onChange={(e) => setZona(String(e.target.value || "").toUpperCase())}
              onBlur={(e) => setZona(limpiarZona(e.target.value))}
              sx={{ mt: 1 }}
              helperText="Zona = Almacén + folio inventario"
            />
            <TextField autoComplete="off"
              label="Folio inventario activo"
              variant="outlined"
              size="small"
              fullWidth
              value={invActivo?.folioinventario || ""}
              slotProps={{ input: { readOnly: true } }}
              sx={{ mt: 1 }}
            />
          </Paper>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, minWidth: 0 }}>
          <Paper sx={{ p: 2, borderRadius: 2, overflow: "hidden" }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
              <PhotoCameraIcon fontSize="small" /> Foto de catélogo
            </Typography>
            <Paper onDoubleClick={handleDobleClickCamaraFoto} onTouchEnd={handleDobleToqueCamaraFoto} sx={{ borderRadius: 2, overflow: "hidden", bgcolor: "#000", minHeight: 320, position: "relative", cursor: articuloCargado && !loadingFoto ? "pointer" : "default", touchAction: "manipulation" }}>
              {!imagenCapturada ? (
                <>
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{ width: "100%", height: "clamp(280px, 42vh, 460px)", minHeight: 280, display: "block", objectFit: "cover" }}
                  />
                  <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none", display: "grid", placeItems: "center" }}>
                    <Box
                      sx={{
                        width: { xs: 190, sm: 240, md: 280 },
                        aspectRatio: "1 / 1",
                        border: "3px solid",
                        borderColor: barridoColor,
                        borderRadius: 1.5,
                        boxShadow: "0 0 0 999px rgba(0,0,0,0.28)",
                        display: "grid",
                        placeItems: "center",
                      }}
                    >
                      <CenterFocusStrongIcon sx={{ color: barridoColor, fontSize: 48, opacity: 0.9 }} />
                    </Box>
                  </Box>
                </>
              ) : (
                <Box
                  component="img"
                  src={imagenCapturada}
                  sx={{ width: "100%", display: "block", maxHeight: 520, objectFit: "contain" }}
                />
              )}
              <Button
                id="inicializacion-foto-aplicar-visor"
                size="small"
                variant="contained"
                color="primary"
                startIcon={<PlaylistAddCheckIcon fontSize="small" />}
                disabled={aplicarDeshabilitado || !puedeAplicarConteo}
                onClick={(event) => {
                  event.stopPropagation();
                  handleAplicarArticulosTemporales();
                }}
                onDoubleClick={(event) => event.stopPropagation()}
                sx={{
                  position: "absolute",
                  right: 12,
                  bottom: 12,
                  zIndex: 4,
                  minHeight: 32,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 1,
                  fontWeight: 800,
                  textTransform: "none",
                  boxShadow: 4,
                  bgcolor: "rgba(10, 91, 166, 0.92)",
                  "&:hover": { bgcolor: "rgba(8, 75, 136, 0.98)", textDecoration: "underline" },
                }}
              >
                Aplicar
              </Button>
              {miniaturaFoto && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    width: 120,
                    maxWidth: "34%",
                    borderRadius: 1.5,
                    overflow: "hidden",
                    bgcolor: "background.paper",
                    border: "2px solid",
                    borderColor: "success.main",
                    boxShadow: 4,
                    pointerEvents: "none",
                  }}
                >
                  <Box component="img" src={miniaturaFoto} sx={{ width: "100%", display: "block", aspectRatio: "1 / 1", objectFit: "cover" }} />
                  <Typography variant="caption" sx={{ display: "block", px: 0.75, py: 0.35, fontWeight: 800, textAlign: "center", color: "success.main" }}>Foto guardada</Typography>
                </Box>
              )}
            </Paper>
            <canvas ref={canvasRef} style={{ display: "none" }} />
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              capture="environment"
              onChange={handleSubirFoto}
              style={{ display: "none" }}
            />
          </Paper>

          <Paper sx={{ p: 2, borderRadius: 2, overflow: "hidden" }}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
              <PsychologyIcon fontSize="small" color="primary" /> Entrenamiento IA
            </Typography>
            {articuloCargado ? (
              <Box>
                <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                  <Typography variant="caption">Vectores: <strong>{vectores}</strong></Typography>
                  <Typography variant="caption" sx={{ fontWeight: 800 }}>{porcentaje}%</Typography>
                </Stack>
                <LinearProgress variant="determinate" value={porcentaje} color={getStatusColor(porcentaje)} sx={{ height: 8, borderRadius: 4 }} />
                {sampleProgress.active && (
                  <Typography variant="caption" color="primary" sx={{ display: "block", mt: 0.5, fontWeight: 700 }}>
                    Muestra {sampleProgress.current} de {sampleProgress.total}
                  </Typography>
                )}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">Cargue un artículo para ver su entrenamiento</Typography>
            )}
          </Paper>

          {invActivo && (
            <Paper sx={{ p: 1.5, borderRadius: 2, bgcolor: "grey.50" }}>
              <Typography variant="caption" color="text.secondary">
                Inventario: {invActivo.descripcion || ""} | Almacén: {invActivo.almacenexhibidor || ""}
              </Typography>
            </Paper>
          )}
        </Box>
      </Box>

      <ModalBuscarArticulosParaVenta
        key={almacenExhibidor || "sin-almacen"}
        openModal={openBuscarModal}
        handleCloseModal={() => setOpenBuscarModal(false)}
        dominio={almacenExhibidor}
        articuloSelect={handleArticuloSeleccionado}
        skipFullData={false}
      />
      <FrmLoginValidate
        openModal={openLoginEliminarIA}
        tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
        handleComandoEjecucion={async () => { await ejecutarEliminarEntrenamiento(); setOpenLoginEliminarIA(false); }}
        hancleCloseModalValidator={() => setOpenLoginEliminarIA(false)}
      />
      <Backdrop
        open={aplicandoTemporales}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1, flexDirection: "column", gap: 1.5 }}
      >
        <CircularProgress color="inherit" />
        <Typography sx={{ fontWeight: 700, textAlign: "center", px: 2 }}>
          {procesoAplicar || "Aplicando lista temporal..."}
        </Typography>
      </Backdrop>
      </Box>
    </SizeSoftXLayoutForm>
  );
}
